import React from 'react';
import { Link } from 'react-router-dom';
import logo from './logo.svg';
import I18n from '../../../config/i18n';

import './logo.css';

const Logo = () => (
  <Link to={`/${I18n.locale}`} reloadDocument className="logo-link">
    <img src={logo} className="logo" alt="Casapilot logo" />
  </Link>
);

export default Logo;
